import * as tslib_1 from "tslib";
import React from 'react';
import FormLabelContainer from './FormLabelContainer';
import FormLabelContent from './FormLabelContent';
/**
 * 表单项中的标签
 *
 * @ReactComponent
 */
function FormLabel(_a) {
    var required = _a.required, children = _a.children, _b = _a.align, align = _b === void 0 ? 'right' : _b, props = tslib_1.__rest(_a, ["required", "children", "align"]);
    return (React.createElement(FormLabelContainer, tslib_1.__assign({}, props, { align: align }),
        React.createElement(FormLabelContent, { required: required, align: align }, children)));
}
export default FormLabel;
//# sourceMappingURL=FormLabel.js.map